import React from "react";
import PageHeader from "../../components/PageHeader";
import TeamMemberViewComponent from "../../components/TeamMembers/TeamMemberView";

class TeamMemberView extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div
                style={{ flex: 1 }}
                onClick={() => {
                    document.body.classList.remove("offcanvas-active");
                }}
            >
                <div>
                    <div className="container-fluid">
                        <PageHeader
                            HeaderText="Team Member Detail"
                            Breadcrumb={[
                                { name: "Team Members", navigate: "/team-members" },
                                { name: "Team Member", navigate: "" },
                            ]}
                        />
                        <div className="row clearfix">
                            <TeamMemberViewComponent />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamMemberView;
